<template>
  <div class="chat">
    <p>如有问题，请联系<a @click="openLive800">在线客服</a></p>
  </div>
</template>

<script>
export default {
  name: 'Chat',
  methods: {
    openLive800() {
      var url =
      `https://onlinecs.cffx139.net/Web/im.aspx?_=t&accountid=137707&visitorid=${new Date().getTime()}`
      var left = screen.width / 2 - 600 / 2
      var top = screen.height / 2 - 400 / 2
      window.open(
        url,
        'DescriptiveWindowName',
        'resizable,scrollbars=yes,status=1,width=800, height=550, top=' +
          top +
          ', left=' +
          left
      )
    }
  }
}
</script>
